import { FRAME_SCALE_MIN, FRAME_SCALE_MAX } from './layerTypeConfig';
import type { LayerFrame } from './types';

const num = (v: number, fallback: number) => (Number.isFinite(v) ? v : fallback);
const clamp = (v: number, lo: number, hi: number) => Math.min(hi, Math.max(lo, v));

/** Sanitize a reframe: scale 1–3, offsets −1..1; non-finite → neutral. */
export function clampLayerFrame(frame: LayerFrame): LayerFrame {
  return {
    scale: clamp(num(frame.scale, 1), FRAME_SCALE_MIN, FRAME_SCALE_MAX),
    offsetX: clamp(num(frame.offsetX, 0), -1, 1),
    offsetY: clamp(num(frame.offsetY, 0), -1, 1),
  };
}
